import React from 'react';
import ReactTooltip from "react-tooltip";
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';

function JacketInfo(props) {

    const { jacketInfo, toggleEditName, toggleAddonModal, toggleScanModal, authentication } = props;

    const editicon = require("../../images/editicon.png").default;
    const addonicon = require("../../images/addon.png").default;
    const scannericon = require("../../images/scanner.png").default;
    const gridview = require("../../images/gridview.png").default;
    const listview = require("../../images/listview.png").default;
    const date_options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    const { jacket_id, org_id} = useParams();
    // const dealjacket_id = props.match.params.jacket_id;
    // const org_id = props.match.params.org_id;

    return (
        <div className="jacketInfo">
            <div className="jacketInfoHeader">
                {jacketInfo.deal_jacket_name}&nbsp;&nbsp;
                {
                    authentication?.user?.org_id === 1 &&
                    (
                        <>
                            <div className="editJacketNameIcon" onClick={toggleEditName} data-tip data-for="edit name">
                                <img src={editicon} width="16px" alt="edit" />
                            </div>
                            <ReactTooltip id="edit name" place="bottom" effect="solid" data-type="info" delayShow={200}>
                                edit name
                            </ReactTooltip>

                        </>
                    )
                }
                <div className="addonIcon" onClick={toggleAddonModal} data-tip data-for="addon">
                    <img src={addonicon} width="18px" alt="add" />
                </div>
                <ReactTooltip id="addon" place="bottom" effect="solid" data-type="info" delayShow={200}>
                    upload local files to jacket
                </ReactTooltip>
                <div className="scannerIcon" onClick={toggleScanModal} data-tip data-for="scanner">
                    <img src={scannericon} width="18px" alt="add" />
                </div>
                <ReactTooltip id="scanner" place="bottom" effect="solid" data-type="info" delayShow={200}>
                    scan and upload to jacket
                </ReactTooltip>                
            </div>
            <br />
            <table className="jacketInfoTable">
                <tbody>
                    <tr>
                        <td>date added:</td>
                        <td>{new Date(jacketInfo.date_added).toLocaleDateString("en-US", date_options)}</td>
                    </tr>
                    <tr>
                        <td>num. pages:</td>
                        <td>{jacketInfo.pageCount}</td>
                    </tr>
                </tbody>
            </table>
            <div className="jacketInfoViewRow">
                <Link to={{ pathname: "/org/" + org_id + "/dealjacket/" + jacket_id + "/list"}}>
                    <img width="24px" src={listview} alt="list view"/>
                </Link>
                <ReactTooltip
                        id="list view"
                        place="bottom"
                        effect="solid"
                        data-type="info"
                        delayShow={300}
                    >
                        view pages in list
                </ReactTooltip>
                <Link to={{ pathname: "/org/" + org_id + "/dealjacket/" + jacket_id + "/grid"}}>
                    <img width="24px" src={gridview} alt="grid view"/>
                </Link>
                <ReactTooltip
                        id="grid view"
                        place="bottom"
                        effect="solid"
                        data-type="info"
                        delayShow={300}
                    >
                        view pages in grid
                </ReactTooltip>
            </div>
        </div>

    )

}

export { JacketInfo }
